// extracted by mini-css-extract-plugin
export var badgesContainer = "lpCompetitorReviewBadges-module--badgesContainer--59f6a";
export var container = "lpCompetitorReviewBadges-module--container--43197";
export var heading = "lpCompetitorReviewBadges-module--heading--21d8e";
export var subheading = "lpCompetitorReviewBadges-module--subheading--93720";